import React, { useState, useEffect } from 'react';

function LapSJ() {
  const [LapPasangData, setLapPasangData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);  
  const [searchQuery, setSearchQuery] = useState(''); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const schema = localStorage.getItem('schema');

  const today = new Date();
  const last30Days = new Date(today);
  last30Days.setDate(today.getDate() + 30);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    return date.toISOString().split('T')[0];
  };

  const formatNumber = (value) => {
    if (isNaN(value)) return value;
    return new Intl.NumberFormat('id-ID', { minimumFractionDigits: 0 }).format(Number(value));
  };


  const [start_date, setStartDate] = useState(formatDate(today));
  const [end_date, setEndDate] = useState(formatDate(last30Days));

  const [filters, setFilters] = useState({
    TGL_DO: '',
    TGL_SURAT_JALAN: '',
    NO_SJ: '',
    REKANAN: '',
    NO_DO: '',
    KD_KENDARAAN: '',
    NOPOL: '',
    SOPIR: '',    
    KOTA_ASAL: '',
    KOTA_TUJUAN: '',
    NO_SJ: ''    
  });

  const fetchLapPasangData = async () => {
    setLoading(true);
    setError(null);
    try {
      if (!start_date || !end_date) {
        throw new Error('Tanggal awal dan akhir harus diisi');
      }

      const url = `${process.env.REACT_APP_API_BASE_URL}/laporan.php?caller=lap_sj&schema=${schema}&start_date=${start_date}&end_date=${end_date}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setLapPasangData(data);
        setFilteredData(data);
      } else {
        throw new Error('Invalid data format from API');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (start_date && end_date) {
      fetchLapPasangData();
    }
  }, [start_date, end_date]);

  useEffect(() => {
    applyFilters();
  }, [filters, LapPasangData]);

  const applyFilters = () => {
    let filtered = LapPasangData.filter((item) => 
      Object.keys(filters).every((key) =>
        filters[key] === '' || String(item[key]).toLowerCase().includes(filters[key].toLowerCase())
      )
    );
    setFilteredData(filtered);
  };

  const handleColumnFilter = (e, key) => {
    setFilters({ ...filters, [key]: e.target.value });
  };

  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });

    setFilteredData(sortedData);
  };

  const getSortIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  return (
    <div>
      <div className="section-header">
        <h2>Laporan Surat Jalan</h2>
        <div className="responsive-filter">
          <label>Periode: </label>
          <input type="date" value={start_date} onChange={(e) => setStartDate(e.target.value)} />
          <input type="date" value={end_date} onChange={(e) => setEndDate(e.target.value)} />
          <button onClick={fetchLapPasangData}>Refresh</button>
        </div>
      </div>

      <div style={{ overflowX: 'auto', background: '#fff', borderRadius: '0 0 10px 10px', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
        <table className="responsive-table">
          <thead>
            <tr>
              <th onClick={() => handleSort('TGL_DO')} style={{ cursor: 'pointer', width: '100px' }}>
                TGL DO {getSortIcon('TGL_DO')}
              </th>
              <th onClick={() => handleSort('TGL_SURAT_JALAN')} style={{ cursor: 'pointer', width: '100px' }}>
                TGL SJ {getSortIcon('TGL_SURAT_JALAN')}
              </th>
              <th onClick={() => handleSort('NO_SURAT_JALAN')} style={{ cursor: 'pointer', width: '100px' }}>
                NO SJ {getSortIcon('NO_SURAT_JALAN')}
              </th>
              <th onClick={() => handleSort('REKANAN')} style={{ cursor: 'pointer', width: '100px' }}>
                REKANAN {getSortIcon('REKANAN')}
              </th>
              <th onClick={() => handleSort('NO_DO')} style={{ cursor: 'pointer', width: '250px' }}>
                NO DO {getSortIcon('NO_DO')}
              </th>
              <th onClick={() => handleSort('KD_KENDARAAN')} style={{ cursor: 'pointer', width: '100px' }}>
                KD KENDARAAN {getSortIcon('KD_KENDARAAN')}
              </th>
              <th onClick={() => handleSort('NOPOL')} style={{ cursor: 'pointer', width: '100px' }}>
                NOPOL {getSortIcon('NOPOL')}
              </th>
              <th onClick={() => handleSort('SOPIR')} style={{ cursor: 'pointer', width: '100px' }}>
                SOPIR {getSortIcon('SOPIR')}
              </th>
              <th onClick={() => handleSort('KOTA_ASAL')} style={{ cursor: 'pointer', width: '100px' }}>
                KOTA ASAL {getSortIcon('KOTA_ASAL')}
              </th>
              <th onClick={() => handleSort('KOTA_TUJUAN')} style={{ cursor: 'pointer', width: '100px' }}>
                KOTA TUJUAN {getSortIcon('KOTA_TUJUAN')}
              </th>
              <th onClick={() => handleSort('SUBCITY')} style={{ cursor: 'pointer', width: '100px' }}>
                SUBCITY {getSortIcon('SUBCITY')}
              </th>
              <th onClick={() => handleSort('TOTAL_BERAT')} style={{ cursor: 'pointer', width: '60px' }}>
                BERAT {getSortIcon('TOTAL_BERAT')}
              </th>
              <th onClick={() => handleSort('TOTAL_KUBIK')} style={{ cursor: 'pointer', width: '60px' }}>
                KUBIK {getSortIcon('TOTAL_KUBIK')}
              </th>
              <th onClick={() => handleSort('TOTAL_INVOICE')} style={{ cursor: 'pointer', width: '60px' }}>
                TOTAL INV {getSortIcon('TOTAL_INVOICE')}
              </th>
            </tr>
            <tr>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'TGL_DO')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'TGL_SURAT_JALAN')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'NO_SURAT_JALAN')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'REKANAN')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'NO_DO')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'KD_KENDARAAN')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'NOPOL')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'SOPIR')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'KOTA_ASAL')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'KOTA_TUJUAN')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'SUBCITY')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'TOTAL_BERAT')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'TOTAL_KUBIK')} placeholder="Filter..." /></th>
              <th><input style={{ width: '80%' }} type="text" onChange={(e) => handleColumnFilter(e, 'TOTAL_INVOICE')} placeholder="Filter..." /></th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item) => (
                <tr key={item.ID}>
                  {['TGL_DO', 'TGL_SURAT_JALAN', 'NO_SURAT_JALAN', 'REKANAN', 'NO_DO', 'KD_KENDARAAN','NOPOL','SOPIR','KOTA_ASAL','KOTA_TUJUAN','SUBCITY', 'TOTAL_BERAT','TOTAL_KUBIK','TOTAL_INVOICE'].map((key) => (
                    <td
                      key={key}
                      style={{ textAlign: key === 'TOTAL_INVOICE' ? 'right' : 'left' }}
                    >
                      {key === 'TOTAL_INVOICE' ? formatNumber(item[key]) : item[key]}
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="11" style={{ textAlign: 'center', padding: '10px' }}>Tidak ada data</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default LapSJ;
